import { z } from "zod";
export const FileUploadResponse = z.object({
    id: z.string().uuid(),
    filename: z.string(),
    mimeType: z.string(),
    byteSize: z.number().int().nonnegative(),
    contentHash: z.string(),
    chunksCreated: z.number().int().nonnegative(),
    deduplicated: z.boolean(),
});
export const FileSummary = z.object({
    id: z.string().uuid(),
    filename: z.string(),
    mimeType: z.string(),
    byteSize: z.number().int().nonnegative(),
    contentHash: z.string(),
    createdAt: z.string().datetime(),
    chunkCount: z.number().int().nonnegative(),
});
export const FilesListResponse = z.object({
    files: z.array(FileSummary),
});
//# sourceMappingURL=files.js.map